import { render, staticRenderFns } from "./ObserveVisibility.vue?vue&type=template&id=0fade2ef&scoped=true"
import script from "./ObserveVisibility.vue?vue&type=script&lang=js"
export * from "./ObserveVisibility.vue?vue&type=script&lang=js"
import style0 from "./ObserveVisibility.vue?vue&type=style&index=0&id=0fade2ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fade2ef",
  null
  
)

export default component.exports